import axios from 'axios';
import { BACKEND_URL } from '@/lib/env';

const API = `${BACKEND_URL}/api/dashboard/business-value`;

export const DATE_PRESETS = [
  { id: 'last_7_days', label: 'Last 7 days' },
  { id: 'last_30_days', label: 'Last 30 days' },
  { id: 'year_to_date', label: 'Year to date' },
  { id: 'last_year', label: 'Last year' },
  { id: 'custom', label: 'Custom range' },
];

/**
 * @param {{ preset?: string, fromDate?: string, toDate?: string }} range
 */
export function buildDateParams(range) {
  if (range.preset && range.preset !== 'custom') {
    return { preset: range.preset };
  }
  if (range.fromDate && range.toDate) {
    return { from_date: range.fromDate, to_date: range.toDate };
  }
  return { preset: 'last_7_days' };
}

export async function fetchTicketTypeSettings() {
  const { data } = await axios.get(`${API}/ticket-type-settings`);
  return data;
}

export async function updateTicketTypeSetting(ticketTypeKey, payload) {
  const { data } = await axios.put(
    `${API}/ticket-type-settings/${encodeURIComponent(ticketTypeKey)}`,
    payload
  );
  return data;
}

export async function fetchTokenUsage(range) {
  const { data } = await axios.get(`${API}/token-usage`, {
    params: buildDateParams(range),
  });
  return data;
}

export async function fetchUsageDrillDown(range) {
  const { data } = await axios.get(`${API}/usage-drill-down`, {
    params: buildDateParams(range),
  });
  return data;
}

export async function fetchSavings(range) {
  const { data } = await axios.get(`${API}/savings`, {
    params: buildDateParams(range),
  });
  return data;
}

export async function fetchPricingSettings() {
  const { data } = await axios.get(`${API}/pricing-settings`);
  return data;
}

export async function updatePricingSettings(payload) {
  const { data } = await axios.put(`${API}/pricing-settings`, payload);
  return data;
}

export async function fetchModelPricing() {
  const { data } = await axios.get(`${API}/model-pricing`);
  return data;
}

export async function updateModelPricing(modelId, payload) {
  const { data } = await axios.put(
    `${API}/model-pricing/${encodeURIComponent(modelId)}`,
    payload
  );
  return data;
}

export async function deleteModelPricing(modelId) {
  await axios.delete(`${API}/model-pricing/${encodeURIComponent(modelId)}`);
}
